import { EDITIONS, type Edition } from '@zyx/shared';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';
import { editionLabel } from '@/lib/format';

/** A filter's trigger: on a phone they share the width, two to a line; from `sm` each keeps its own. */
export const FILTER_TRIGGER = 'min-w-0 grow basis-36 sm:w-44 sm:grow-0 sm:basis-auto';

const ANY = 'any';

/** An edition from a URL or a select; anything else, such as "any", is no edition. */
export function parseEdition(value: string | null): Edition | undefined {
  return EDITIONS.find((candidate) => candidate === value);
}

export function EditionFilter(props: { readonly value: Edition | undefined; readonly onChange: (edition: Edition | undefined) => void }) {
  return (
    <Select value={props.value ?? ANY} onValueChange={(value) => props.onChange(parseEdition(value))}>
      <SelectTrigger className={FILTER_TRIGGER} aria-label="Edition">
        <SelectValue />
      </SelectTrigger>
      <SelectContent>
        <SelectItem value={ANY}>Any edition</SelectItem>
        {EDITIONS.map((candidate) => (
          <SelectItem key={candidate} value={candidate}>
            {editionLabel(candidate)}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
}
